import React, { useRef } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChatModal from '../components/ChatModal';
import iconTema from '../assets/icon-Tema.png'
import BannerCam from '../assets/Banner-Cam.png'

const CaminhaoPage = () => {
  const chatModalRef = useRef(null);

  const handleOpenChat = () => {
    if (chatModalRef.current) {
      chatModalRef.current.openModal();
    }
  };
  return (
    <div>
      <Header onOpenChat={handleOpenChat} />
      
      {/* Hero Section */}
      <section className="relative gradient-bg text-white section-padding pt-26 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-20">
          <img 
            src="https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
            alt="Modern Truck"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-green/80 via-somax-green/70 to-somax-dark/90"></div>
        </div>
        
        {/* Floating Elements */}
        <div className="absolute top-20 right-20 w-24 h-24 border-2 border-somax-yellow/30 rounded-lg rotate-12 floating-animation"></div>
        <div className="absolute bottom-32 left-10 w-16 h-16 bg-somax-yellow/20 rounded-full floating-animation" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-40 left-1/3 w-8 h-8 bg-white/30 rounded-lg rotate-45 floating-animation" style={{animationDelay: '2s'}}></div>
        
        <div className="container-custom relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-last lg:order-first md:mt-0 mt-[-120px] z-10">
              <div className="inline-block p-3 bg-somax-yellow/20 rounded-2xl mb-6 backdrop-blur-sm">
                 <img 
                 src={iconTema}
                 alt="Dream Home"
                  className="w-12 h-12 rounded-lg"
                />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 text-shadow-lg glow-text">
                Você não compra um caminhão, você compra <span className="text-somax-yellow bg-gradient-to-r from-somax-yellow to-yellow-300 bg-clip-text text-transparent">PROSPERIDADE</span>
              </h1>
              <p className="text-xl mb-8 text-somax-light leading-relaxed">
                Transforme seu trabalho em um negócio próspero. Com o consórcio de caminhões Somax, 
                você investe no seu futuro e <span className="font-semibold text-somax-yellow">multiplica sua renda.</span>
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={handleOpenChat}
                  className="btn-secondary text-lg px-8 py-4 bg-gradient-to-r from-somax-yellow to-yellow-500 hover:from-yellow-500 hover:to-somax-yellow transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-somax-yellow/25"
                >
                  <span className="flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                    Quero Crescer Meu Negócio!
                  </span>
                </button>
                <div className="text-somax-yellow font-bold text-lg flex items-center bg-white/10 px-4 py-2 rounded-lg backdrop-blur-sm border border-somax-yellow/30">
                  <span className="animate-pulse mr-2">🔥</span> Grupo especial para transportadores
                </div>
              </div>
            </div>
          <div className="order-first lg:order-last">
            <img 
              src={BannerCam}
              alt="Banner Caminhão Somax"
              className="w-full h-full object-cover transition-all duration-500 ease-in-out group-hover:scale-110 group-hover:rotate-1 group-hover:brightness-110"
            />
          </div>
          {/* Overlay com efeito hover */}
          <div className="absolute inset-0 bg-gradient-to-t from-somax-green/20 via-transparent to-somax-yellow/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          
          {/* Elementos flutuantes animados apenas no hover */}
          <div className="absolute top-4 right-4 w-16 h-16 border-2 border-somax-yellow/50 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-pulse transition-all duration-500"></div>
          <div className="absolute bottom-4 left-4 w-12 h-12 bg-somax-yellow/30 rounded-lg rotate-45 opacity-0 group-hover:opacity-100 group-hover:animate-bounce transition-all duration-500" style={{animationDelay: '0.5s'}}></div>
          <div className="absolute top-1/2 left-8 w-8 h-8 bg-white/40 rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping transition-all duration-500" style={{animationDelay: '1s'}}></div>
            {/* <div className="text-center relative">
              <div className="relative inline-block">
                <div className="absolute inset-0 bg-somax-yellow/20 rounded-full blur-3xl scale-150"></div>
                <img 
                  src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80" 
                  alt="Professional Truck"
                  className="relative z-10 w-80 h-60 object-cover rounded-2xl shadow-2xl floating-animation"
                />
              </div>
              <p className="text-somax-light text-lg mt-6 font-medium">Seu império logístico começa aqui</p>
            </div> */}
          </div>
        </div>
      </section>

      {/* Authority Section */}
      <section className="section-padding bg-somax-dark text-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="text-somax-yellow">Especialistas</span> em Financiamento de Caminhões
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Há mais de 10 anos ajudando transportadores a expandir seus negócios
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-somax-green mb-2">2.500+</div>
              <p className="text-gray-300">Caminhões financiados</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-somax-yellow mb-2">95%</div>
              <p className="text-gray-300">Taxa de aprovação</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-somax-green mb-2">R$ 50M</div>
              <p className="text-gray-300">Em créditos liberados</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-somax-yellow mb-2">24h</div>
              <p className="text-gray-300">Análise de crédito</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pain Points Section */}
      <section className="relative section-padding bg-gradient-to-br from-red-900/20 via-red-800/10 to-red-700/20 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-10">
          <img 
            src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
            alt="Truck Problems"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-red-900/60 via-red-800/40 to-red-700/60"></div>
        </div>
        
        {/* Floating Elements */}
        <div className="absolute top-10 right-10 w-20 h-20 border-2 border-red-400/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-20 left-20 w-12 h-12 bg-red-500/20 rounded-lg rotate-45 floating-animation" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-1/2 right-1/4 w-6 h-6 bg-red-300/40 rounded-full floating-animation" style={{animationDelay: '0.5s'}}></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-3 bg-red-500/20 rounded-2xl mb-6 backdrop-blur-sm">
              <svg className="w-12 h-12 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-red-400 mb-4 text-shadow-lg glow-text">
              Seu negócio está limitado por estes problemas?
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-red-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">📉</div>
              <h3 className="text-xl font-bold text-red-400 mb-2">Caminhão Velho</h3>
              <p className=" leading-relaxed">Quebras constantes, manutenção cara, perda de fretes por falta de confiabilidade...</p>
              <div className="mt-4 w-full bg-red-900/30 rounded-full h-2">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2 rounded-full w-3/4 animate-pulse"></div>
              </div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-red-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">💰</div>
              <h3 className="text-xl font-bold text-red-400 mb-2">Renda Limitada</h3>
              <p className=" leading-relaxed">Trabalhando para outros, sem crescer, sem patrimônio, sem futuro garantido...</p>
              <div className="mt-4 w-full bg-red-900/30 rounded-full h-2">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2 rounded-full w-2/3 animate-pulse" style={{animationDelay: '0.5s'}}></div>
              </div>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-red-400/30 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl mb-4">⏳</div>
              <h3 className="text-xl font-bold text-red-400 mb-2">Tempo Perdido</h3>
              <p className=" leading-relaxed">Horas parado na oficina, fretes perdidos, clientes insatisfeitos...</p>
              <div className="mt-4 w-full bg-red-900/30 rounded-full h-2">
                <div className="bg-gradient-to-r from-red-500 to-red-400 h-2 rounded-full w-4/5 animate-pulse" style={{animationDelay: '1s'}}></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="relative section-padding bg-somax-light">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4">
              A solução para <span className="text-gradient">MULTIPLICAR</span> sua renda
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Caminhão novo = Mais fretes + Menos manutenção + Maior lucro
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-green rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">1</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Confiabilidade Total</h3>
                    <p className="text-gray-600">Caminhão 0km, sem surpresas, sem quebras, sem dor de cabeça.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-yellow rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-somax-dark font-bold">2</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Mais Fretes</h3>
                    <p className="text-gray-600">Clientes preferem caminhões novos. Mais contratos, mais dinheiro.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-somax-gray rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">3</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-somax-dark mb-2">Patrimônio Crescente</h3>
                    <p className="text-gray-600">Cada parcela é um investimento no seu futuro e da sua família.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-lg shadow-xl">
              <h3 className="text-2xl font-bold text-somax-dark mb-6 text-center">Tipos de Caminhão</h3>
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span className="font-medium">Caminhão 3/4</span>
                  <span className="text-somax-green font-bold">R$ 800/mês</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span className="font-medium">Caminhão Toco</span>
                  <span className="text-somax-green font-bold">R$ 1.200/mês</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span className="font-medium">Carreta/Bitrem</span>
                  <span className="text-somax-green font-bold">R$ 1.800/mês</span>
                </div>
              </div>
              <button 
                onClick={handleOpenChat}
                className="btn-primary w-full mt-6"
              >
                Calcular Meu Investimento
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Success Cases Section */}
      <section className="relative section-padding bg-gradient-to-br from-somax-green/10 via-somax-light/20 to-somax-light overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-5">
          <img 
            src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
            alt="Success Stories"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-green/20 via-somax-light/30 to-somax-light/40"></div>
        </div>
        
        {/* Floating Elements */}
        <div className="absolute top-16 right-16 w-20 h-20 border-2 border-somax-green/30 rounded-full floating-animation"></div>
        <div className="absolute bottom-24 left-16 w-14 h-14 bg-somax-yellow/20 rounded-lg rotate-12 floating-animation" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/3 right-1/3 w-8 h-8 bg-somax-green/30 rounded-full floating-animation" style={{animationDelay: '2s'}}></div>
        
        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-3 bg-somax-green/20 rounded-2xl mb-6 backdrop-blur-sm">
              <svg className="w-12 h-12 text-somax-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4 text-shadow-lg glow-text">
              Casos de <span className="text-somax-green bg-gradient-to-r from-somax-green to-somax-green/80 bg-clip-text text-transparent">SUCESSO</span> reais
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">Transportadores que multiplicaram sua renda com a Somax</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-somax-green/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-somax-green to-somax-green/80 rounded-full flex items-center justify-center mr-4 shadow-lg">
                  <span className="text-white font-bold text-xl">R</span>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-somax-dark">Roberto Silva</h4>
                  <p className="text-gray-600">Transportador - São Paulo</p>
                </div>
              </div>
              <div className="mb-4">
                <div className="text-3xl font-bold text-somax-green mb-2 glow-text">R$ 15.000/mês</div>
                <p className="text-gray-600">Renda atual com 2 caminhões</p>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-gradient-to-r from-somax-green to-somax-green/80 h-2 rounded-full w-4/5 animate-pulse"></div>
                </div>
              </div>
              <p className="text-gray-700 italic mb-4 leading-relaxed">
                "Comecei com 1 caminhão pela Somax. Em 2 anos já tenho 2 e estou planejando o terceiro. 
                Minha renda triplicou!"
              </p>
              <div className="flex text-somax-yellow text-xl">
                ⭐⭐⭐⭐⭐
              </div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-somax-yellow/20 card-hover transform hover:scale-105 transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-somax-yellow to-yellow-400 rounded-full flex items-center justify-center mr-4 shadow-lg">
                  <span className="text-somax-dark font-bold text-xl">C</span>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-somax-dark">Carlos Mendes</h4>
                  <p className="text-gray-600">Empresário - Minas Gerais</p>
                </div>
              </div>
              <div className="mb-4">
                <div className="text-3xl font-bold text-somax-green mb-2 glow-text">R$ 25.000/mês</div>
                <p className="text-gray-600">Faturamento da transportadora</p>
                <div className="mt-2 w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-gradient-to-r from-somax-yellow to-yellow-400 h-2 rounded-full w-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
                </div>
              </div>
              <p className="text-gray-700 italic mb-4 leading-relaxed">
                "Saí de motorista para empresário. Hoje tenho 4 caminhões e 8 funcionários. 
                A Somax foi fundamental nessa jornada!"
              </p>
              <div className="flex text-somax-yellow text-xl">
                ⭐⭐⭐⭐⭐
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ROI Calculator Section */}
      <section className="section-padding bg-somax-dark text-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Calcule seu <span className="text-somax-yellow">RETORNO</span>
            </h2>
            <p className="text-xl text-gray-300">Veja quanto você pode ganhar com seu caminhão novo</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="bg-white text-somax-dark p-8 rounded-lg">
              <h3 className="text-2xl font-bold mb-6 text-center">Simulação de Ganhos</h3>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span>Frete médio/dia:</span>
                  <span className="font-bold text-somax-green">R$ 400</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span>Dias trabalhados/mês:</span>
                  <span className="font-bold text-somax-green">22 dias</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-somax-light rounded-lg">
                  <span>Faturamento bruto:</span>
                  <span className="font-bold text-somax-green">R$ 8.800</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-red-100 rounded-lg">
                  <span>Custos operacionais:</span>
                  <span className="font-bold text-red-600">- R$ 3.500</span>
                </div>
                <div className="flex justify-between items-center p-4 bg-yellow-100 rounded-lg">
                  <span>Parcela do consórcio:</span>
                  <span className="font-bold text-yellow-600">- R$ 1.200</span>
                </div>
                <div className="border-t-2 border-somax-green pt-4">
                  <div className="flex justify-between items-center text-xl font-bold">
                    <span>LUCRO LÍQUIDO:</span>
                    <span className="text-somax-green">R$ 4.100/mês</span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-2xl font-bold mb-6">Vantagens Exclusivas</h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="w-8 h-8 bg-somax-green rounded-full flex items-center justify-center">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>Parcelas fixas sem surpresas</span>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-8 h-8 bg-somax-green rounded-full flex items-center justify-center">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>Seguro total incluso</span>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-8 h-8 bg-somax-green rounded-full flex items-center justify-center">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>Suporte técnico 24h</span>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="w-8 h-8 bg-somax-green rounded-full flex items-center justify-center">
                    <span className="text-white text-sm">✓</span>
                  </div>
                  <span>Rede de oficinas credenciadas</span>
                </div>
              </div>
              
              <button 
                onClick={handleOpenChat}
                className="btn-secondary mt-8 w-full"
              >
                Quero Começar Agora!
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Urgency Section */}
      <section className="section-padding bg-red-600 text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            🚨 ÚLTIMA CHAMADA: Grupo Especial Transportadores
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Apenas <strong>3 vagas restantes</strong> no grupo exclusivo com condições especiais. 
            Não deixe essa oportunidade passar!
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white text-red-600 p-6 rounded-lg">
              <div className="text-2xl font-bold mb-2">Taxa Reduzida</div>
              <div className="text-lg">50% de desconto na taxa de adesão</div>
            </div>
            <div className="bg-white text-red-600 p-6 rounded-lg">
              <div className="text-2xl font-bold mb-2">Análise Express</div>
              <div className="text-lg">Aprovação em até 12 horas</div>
            </div>
            <div className="bg-white text-red-600 p-6 rounded-lg">
              <div className="text-2xl font-bold mb-2">Suporte VIP</div>
              <div className="text-lg">Consultor exclusivo para transportadores</div>
            </div>
          </div>
          
          <button 
            onClick={handleOpenChat}
            className="bg-somax-yellow hover:bg-yellow-500 text-somax-dark font-bold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 text-lg"
          >
            Garantir Minha Vaga VIP!
          </button>
        </div>
      </section>

      <Footer />
      <ChatModal ref={chatModalRef} />
    </div>
  );
};

export default CaminhaoPage;